import React, {
  createContext,
  useContext,
  useState,
  useMemo,
  useEffect,
  useRef,
} from "react";
import { countriesList } from "../../../utilities/staticData";
import { findConactsFromVendor } from "../../../services/iqApiV2"; // adjust path
import { parseCSV } from "../../../utilities/uiUtils";

const GlobalContactSearchStateContext = createContext(null);

export const GlobalContactSearchStateProvider = ({ children }) => {
  const defaultSeniorities = useMemo(
    () => [
      "owner",
      "founder",
      "c_suite",
      "partner",
      "vp",
      "head",
      "director",
      "manager",
      "senior",
      "entry",
      "intern",
    ],
    []
  );

  const defaultLocations = useMemo(() => countriesList, []);

  const [domains, setDomains] = useState("");
  const [orgDomains, setOrgDomains] = useState("");
  const [jobTitle, setJobTitle] = useState("");
  const [orgJobTitles,setOrgJobTitles] =  useState("");
  const [seniorities, setSeniorities] = useState([]);
  const [personLocations, setPersonLocations] = useState([]);
  const [organizationLocations,setOrganizationLocations]= useState([]);
  const [contactEmailStat,setContactEmailStat]=useState([]);
  const [orgHeadCount,setOrgHeadCount]=useState([]);
  const [page, setpage] = useState(1);
  const [rowsPerPage, setRowsPerPage] = useState(15);
  const [searchedContacts, setSearchedContacts] = useState([]);
  const [totalEntires,setTotalEntires]=useState(0);
  const [paginationData,setPaginationData]=useState({})
  const [searchContactLoading,setSearchContactLoading]=useState(true);
  const [orgRevenue,setOrgRevenue]=useState([]);

  const timeoutRef = useRef(null);

  // Reset page to 1 whenever filters change
  useEffect(() => {
    setpage(1);
  }, [domains, jobTitle, seniorities, personLocations, organizationLocations, contactEmailStat, orgHeadCount, orgJobTitles, orgRevenue]);

  useEffect(() => {
    if (timeoutRef.current) clearTimeout(timeoutRef.current);

    timeoutRef.current = setTimeout(() => {
      const [min, max] = orgRevenue;
      const formattedJobTitles = jobTitle
        ? jobTitle.split(',').map(title => title.trim())
        : [];
      const payload = {
        domain: parseCSV(domains),
        person_titles: formattedJobTitles,
        q_organization_job_titles:orgJobTitles? orgJobTitles :[],
        person_locations: personLocations,
        person_seniorities: seniorities,
        page,
        per_page: rowsPerPage,
        organization_locations:organizationLocations,
        q_organization_domains_list: parseCSV(domains),
        contact_email_status:contactEmailStat,
        organization_num_employees_ranges:orgHeadCount,
        revenue_range: {min, max}
      };
      setSearchContactLoading(true)

      const filteredData = Object.fromEntries(
        Object.entries(payload).filter(([key, value]) => value && (Array.isArray(value) ? value.length > 0 : true))
      );

      findConactsFromVendor({"additionalProp1": filteredData})
        .then((res) => {
          setSearchedContacts(res?.data?.contacts || []);
          setTotalEntires(res?.data?.pagination?.total_entries);
          setPaginationData(res?.data?.pagination)
          setSearchContactLoading(false)
        })
        .catch((err) => {
          console.error("Error fetching contacts", err);
        });
    }, 500);

    return () => clearTimeout(timeoutRef.current);
  }, [domains, jobTitle, seniorities, personLocations,organizationLocations,orgDomains,contactEmailStat,orgHeadCount,orgJobTitles,orgRevenue, page, rowsPerPage]);

  const value = {
    domains,
    setDomains,
    jobTitle,
    setJobTitle,
    seniorities,
    setSeniorities,
    personLocations,
    setPersonLocations,
    defaultSeniorities,
    defaultLocations,
    page,
    setpage,
    rowsPerPage,
    setRowsPerPage,
    searchedContacts,
    setSearchedContacts,
    totalEntires,setTotalEntires,
    paginationData,setPaginationData,
    searchContactLoading,setSearchContactLoading,
    organizationLocations,setOrganizationLocations,
    orgDomains, setOrgDomains,
    contactEmailStat,setContactEmailStat,
    orgHeadCount,setOrgHeadCount,
    orgJobTitles,setOrgJobTitles,
    orgRevenue,setOrgRevenue


  };


  return (
    <GlobalContactSearchStateContext.Provider value={value}>
      {children}
    </GlobalContactSearchStateContext.Provider>
  );
};

export const useGlobalContactSearchState = () => {
  const ctx = useContext(GlobalContactSearchStateContext);
  if (!ctx) {
    throw new Error(
      "useGlobalContactSearchState must be used within a GlobalContactSearchStateProvider"
    );
  }
  return ctx;
};
